import React from 'react';

import {
  GlobalStyles,
} from '../components/GlobalStyles';
import { App } from '../components/App';
import { Seo } from '../components/Seo';
// markup
const IndexPage = () => {
  return (
    <main>
      <Seo/>
      <GlobalStyles />
      <App />
    </main>
  );
};

export default IndexPage;
